"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderBack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const side_panel_1 = require("@alfalab/core-components/side-panel");
const component_context_1 = require("../context/component.context");
const bottom_slot_1 = require("./bottom-slot");
const header_back_button_1 = require("./header-back-button");
const titles_slot_1 = require("./titles-slot");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * <SidePanel.HeaderBack>
 *
 * Заголовок для SidePanel с кнопкой "назад".
 */
const HeaderBack = ({ CoreSidePanel = side_panel_1.SidePanel.Header, className, dataTestId, hasCloser = true, onBackClick, leftAddons, rightAddons, title, subtitle, transparent, sticky = true, bottomAddons, bottomAddonsClassName, }) => {
    const { isMobile, isResponsive, isDesktop } = (0, react_1.useContext)(component_context_1.AdditionalContext);
    const platformStyles = {
        [index_module_css_1.default.mobile]: isMobile,
        [index_module_css_1.default.responsive]: isResponsive,
    };
    const withTitleWrapper = title || subtitle;
    const headerProps = {
        className: (0, classnames_1.default)(index_module_css_1.default.component, { [index_module_css_1.default.transparent]: transparent }, className),
        dataTestId,
        hasCloser,
        sticky: !isDesktop && sticky,
        leftAddons,
        closerClassName: (0, classnames_1.default)(index_module_css_1.default.closer, platformStyles, {
            [index_module_css_1.default.withoutRightAddons]: !rightAddons,
        }),
        addonClassName: (0, classnames_1.default)(index_module_css_1.default.addon, platformStyles),
    };
    return ((0, jsx_runtime_1.jsxs)("section", { className: (0, classnames_1.default)(index_module_css_1.default.wrapper, Object.assign({ [index_module_css_1.default.transparent]: transparent, [index_module_css_1.default.stickyWrapper]: sticky }, platformStyles)), children: [(0, jsx_runtime_1.jsx)(CoreSidePanel, Object.assign({}, headerProps, { children: (0, jsx_runtime_1.jsx)(header_back_button_1.HeaderBackButton, { onClick: onBackClick, rightAddons: rightAddons }) })), withTitleWrapper && (0, jsx_runtime_1.jsx)(titles_slot_1.TitlesSlot, { title: title, subtitle: subtitle }), bottomAddons && (0, jsx_runtime_1.jsx)(bottom_slot_1.BottomSlot, { className: bottomAddonsClassName, addons: bottomAddons })] }));
};
exports.HeaderBack = HeaderBack;
